/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import TransactionsContainer from './dashboard/TransactionsContainer';
import TransactionContainer from './transaction/container/TransactionContainer';

function BillsContainer({ match }) {
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Mobile Load</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/mobile-load"
          >
            Dashboard
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/mobile-load/transaction"
          >
            Transaction
          </NavLink>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={TransactionsContainer}
          />
          <Route
            path={`${match.path}/transaction`}
            component={TransactionContainer}
          />
        </Switch>
      </div>
    </>
  );
}

BillsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(BillsContainer);
